export const CartIcon = () => {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <title>Cart</title>
        <path
          d="M5.00041 15.9374H13.2679C13.5632 15.9375 13.8489 15.833 14.0746 15.6424C14.3002 15.4519 14.451 15.1878 14.5004 14.8966L16.6979 1.97994C16.7475 1.68898 16.8984 1.42495 17.124 1.23461C17.3496 1.04426 17.6352 0.939875 17.9304 0.939941H18.7504M14.9612 12.1876H4.90201C4.34458 12.1875 3.80316 12.0012 3.36378 11.6581C2.92441 11.3151 2.61228 10.835 2.47701 10.2942L1.26868 5.46091C1.24562 5.36873 1.24389 5.27252 1.2636 5.17957C1.28331 5.08662 1.32396 4.99939 1.38246 4.92451C1.44094 4.84962 1.51573 4.78907 1.60115 4.74743C1.68656 4.7058 1.78033 4.68419 1.87535 4.68424H16.237M7.00041 18.05V18M13.0004 18.05V18"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
